/**
 * Field-level error message, meant to be linked to its `<input>` via
 * `aria-describedby={id}` so assistive tech announces it (WCAG 2.2 AA —
 * "erros anunciados"). Renders nothing when there's no message so callers
 * can always mount it unconditionally (`<FieldError id={..} message={errors.foo} />`).
 * Text-accent matches the design system's "accent = dado/alerta, nunca
 * decoração" rule — this is exactly an alert use.
 */
export function FieldError({ id, message }: { id: string; message?: string | undefined }) {
  if (!message) {
    return null;
  }
  return (
    <p id={id} role="alert" className="text-sm font-medium text-accent">
      {message}
    </p>
  );
}
